// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3fg__","left":"styles_left__3l-ZZ","desktopActions":"styles_desktopActions__3wXsX","title":"styles_title__2hXRT"};